export default __webpack_public_path__ + "images/1f90803a2691ec8ac2730cd45a3990fd-design.jpg";